module.exports = __webpack_public_path__ + "static/img/basic_operation02.56d2bf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bird/basic_operation02.png
// module id = 86z/
// module chunks = 1